import { applyFilters, doRequest } from "./helpers";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

export default class ProductService {
  static async getTable(filters = null) {
    let path = "/product/";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getForFilters(filters = null) {
    let path = "/product/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async get(id) {
    return doRequest("GET", `/product/${id}`);
  }

  static async create(data) {
    return doRequest("POST", "/product/", { data: omitBy(data, isNil) });
  }

  static async update(id, data) {
    return doRequest("PUT", `/product/${id}`, { data: omitBy(data, isNil) });
  }

  static async delete(id) {
    return doRequest("DELETE", `/product/${id}`);
  }
}
